<template>
  <!-- <a-result status="403" title="403" sub-title="抱歉，你没有此页面的访问权限。">
    <template #extra>
      <a-button type="primary" @click="backHome">回到首页</a-button>
    </template>
  </a-result> -->
  <div class="server-403">
    <div class="server-left">
      <img src="@/assets/403.png" alt="" />
    </div>
    <div class="server-text">
      <div class="server-text-1">您的权限不足...</div>
      <div class="server-text-2">哎呀！您不能操作此模块</div>
      <div class="server-text-3">建议您联系管理员开通此模块的操作权限</div>
      <div class="back-center">
        <a-button type="primary" @click="backHome">返回首页</a-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    backHome() {
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss" scoped>
.server-403 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  overflow: hidden;
}
.server-left {
  width: 450px;
  margin-right: 40px;
  img {
    width: 100%;
    height: 100%;
  }
}
.server-text {
  height: auto;
  overflow: hidden;
  letter-spacing: 1px;
  .server-text-1 {
    height: auto;
    overflow: hidden;
    color: #1890ff;
    font-size: 50px;
    font-family: "黑体";
  }
  .server-text-2,
  .server-text-3 {
    height: auto;
    overflow: hidden;
    color: #333;
    margin: 10px 0;
    font-size: 16px;
  }
  .back-center {
    margin: 30px 0 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/403.vue